<div *showAuthed="true" id="editCredential">
  <list-errors [errors]="credentialFormErrors"></list-errors>
  <form class="card" [hidden]="isSubmitting">
    <fieldset [disabled]="isSubmitting">
      <div class="card-block">
        <angular-editor
          [formControl]="credentialField"
          placeholder="Write a credential..."
          [config]="editorConfig"
        >
        </angular-editor>
      </div>
      <div class="card-footer">
        <div class="container">
          <div class="row post-button-and-image">
            <div class="col-md-2 col-6">
              <img
                *ngIf="currentUser.image"
                class="credential-user-image"
                [src]="currentUser.image"
                alt="credential-user-image"
                style="margin: auto"
              />
              <img
                *ngIf="!currentUser.image"
                class="credential-user-image"
                [src]="defaultUserImg"
                alt="credential-user-image"
                style="margin: auto"
              />
            </div>

            <div class="col-md-2 col-6">
              <div class="preloader4">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
              </div>
            </div>

            <div class="col-md-8 col-12">
              <button
                class="btn btn-primary"
                type="submit"
                (click)="openCredentialPostConfirmation()"
              >
                <i class="fa fa-paper-plane"></i>

                Post Credential
              </button>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </form>

  <!-- Loader spinner -->
  <loader-animation
    [loading]="isSubmitting"
    [message]="'Publishing your credential'"
  >
  </loader-animation>
  <!-- Loader spinner -->
</div>
